import { HelpCircle } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { HELP_TEXTS, type HelpTopic } from "./helpTexts";

/**
 * Icono de ayuda único para toda la app: qué es / para qué sirve un botón o
 * campo. Un solo componente + un solo diccionario (helpTexts.ts).
 */
export const HelpTooltip = ({
  topic,
  className,
}: {
  topic: HelpTopic;
  className?: string;
}) => {
  const text = HELP_TEXTS[topic];
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          onClick={(e) => e.preventDefault()}
          className={
            "text-muted-foreground hover:text-foreground inline-flex size-4 shrink-0 items-center justify-center align-middle " +
            (className ?? "")
          }
          aria-label={text.que}
        >
          <HelpCircle className="size-3.5" />
        </button>
      </TooltipTrigger>
      <TooltipContent className="max-w-64 space-y-0.5 text-left">
        <p className="font-semibold">{text.que}</p>
        <p>{text.para}</p>
      </TooltipContent>
    </Tooltip>
  );
};
